/* eslint-disable no-param-reassign */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

import request, { apiHost } from '../utils/request';
import SalesManagerForm from './salesManagerForm';
import { useTranslationsContext } from '../context/TranslationsContext';
import RegisterAsSalesRepAndManager from './schema';
import ProfileInfo from './profileInfo';
import '../../assets/css/registration.css';
import '../../assets/css/registration_media_queries.css';

const fetchChannels = () => {
  return request.get('/channels');
};
const fetchProvince = () => {
  return request.get('/provinces');
};
const Registration = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isError, setError] = useState(null);
  const [recaptcha, setRecaptcha] = useState();
  const [channelsList, setChannelsList] = useState([]);
  var [provincesList, setProvincesList] = useState([]);
  const translations = useTranslationsContext();

  const [processingQueryData, setProcessingQueryData] = useState(true);
  const [isRedirectedFromPassport, setIsRedirectedFromPassport] = useState(
    false
  );
  const [paramsData, setParamsData] = useState({
    firstName: '',
    lastName: '',
    email: ''
  });

  const {
    USERS: {
      USER_AUTHENTICATION: { labels, confirmationDialog, ERRORS_MESSAGES }
    }
  } = translations;

  const initialValues = {
    role: '',
    firstName: paramsData.firstName,
    lastName: paramsData.lastName,
    email: paramsData.email,
    password: '',
    channels: [],
    xid: '',
    storeCode: '',
    channelOrgCode: '',
    dealership: '',
    outlet: '',
    salesManager: '',
    salesManagerEmail: '',
    cpmsId: '',
    requiresOrderAccess: '',
    contactNumber: '',
    provinces: [],
    recaptcha: ''
  };
  // extract and store data from query params (if any)
  useEffect(() => {
    const queryParams = new URLSearchParams(history.location.search);
    const firstName = decodeURIComponent(queryParams.get('firstName') || '');
    const lastName = decodeURIComponent(queryParams.get('lastName') || '');
    const email = decodeURIComponent(queryParams.get('email') || '');

    if (firstName && lastName && email) setIsRedirectedFromPassport(true);

    setParamsData({
      firstName: firstName || '',
      lastName: lastName || '',
      email: email || ''
    });

    setProcessingQueryData(false);
  }, []);
  // Province List
  useEffect(() => {
    fetchProvince().then(response => {
      const list = [];
      // eslint-disable-next-line no-unused-expressions
      response.data.provinces &&
        response.data.provinces.forEach((item, index) => {
          list.push({
            id: item.id,
            value: item.name,
            // labelKey: `${item.name}${index}`
          });
        });
      provincesList = list
      setProvincesList(provincesList);
    });
  }, [])

  const getSingleProvinceOrChannel = (province) => {
    const strArr = []
    strArr.push(province.toString())
    return strArr;
  }
  const getMultiProvinceOrChannel = (values) => {
    const strArr = []
    values.map(item => {
      strArr.push(item.value.toString())
    })
    return strArr;
  }
  const onChange = value => {
    setRecaptcha(value);
  };

  const handleSubmit = async (values, actions) => {
    setError(null);
    setLoading(true);
    values.recaptcha = recaptcha;
    const updatedValues = {
      ...values,
      provinces: values.role !== 'SALES_SUPPORT' ? getSingleProvinceOrChannel(values.provinces) : getMultiProvinceOrChannel(values.provinces),
      channels:
        values.role === 'SALES_SUPPORT'
          ? getMultiProvinceOrChannel(values.channels)
          : getSingleProvinceOrChannel(values && values.channels && values.channels[0] && values.channels[0].value)
    };
    axios
      .post(`${apiHost}/users/register`, updatedValues)
      .then(formData => {
        actions.resetForm(initialValues);
        if (formData.request.status === 200) {
          setShowModal(true);
        }
        setLoading(false);
      })
      .catch(err => {
        const {
          data: { error }
        } = err && err.response;
        setError(error);
        setLoading(false);
      });
  };

  // Channels List
  useEffect(() => {
    fetchChannels().then(response => {
      const list = [];
      // eslint-disable-next-line no-unused-expressions
      response.data.channels &&
        response.data.channels.forEach((item, index) => {
          list.push({
            id: item.id,
            label: item.description,
            value: item.name,
            labelKey: `${item.name}${index}`
          });
        });
      setChannelsList(list);
    });
  }, []);

  return processingQueryData ? (
    <></>
  ) : (
    <>
      <div id="main" className="registration-page" style={{ marginTop: "88px" }}>
        <div id="main-wrapper">
          <div id="main-content">
            <ProfileInfo error={isError} />
            <div id="main-content-login">
              <SalesManagerForm
                initialValues={initialValues}
                schema={RegisterAsSalesRepAndManager}
                labels={labels}
                errorMessages={ERRORS_MESSAGES}
                showModal={showModal}
                loading={loading}
                channelsList={channelsList}
                provincesList={provincesList}
                onChange={value => onChange(value)}
                confirmationDialog={confirmationDialog}
                onSubmit={(values, actions) => {
                  handleSubmit(values, actions);
                }}
                isRedirectedFromPassport={isRedirectedFromPassport}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

Registration.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    location: PropTypes.shape({
      search: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
};

export default Registration;
